const TRUSTED_APP_PATH_PREFIXES = [
  '/my-shifts',
  '/my-calendar',
  '/available-shifts',
  '/shift-allocations',
  '/shiftAllocations',
  '/messages',
  '/profile',
  '/login',
];

const getTrustedOrigins = () => {
  const origins = new Set([window.location.origin]);
  for (const value of [
    process.env.REACT_APP_APP_URL,
    process.env.REACT_APP_WEB_URL,
    process.env.REACT_APP_PUBLIC_URL,
  ]) {
    if (!value) {
      continue;
    }
    try {
      origins.add(new URL(value).origin);
    } catch {
      // Ignore invalid env URLs.
    }
  }
  return origins;
};

const isTrustedAppPath = (path) =>
  TRUSTED_APP_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(`${prefix}?`)
  );

/**
 * Returns true only for in-app relative paths or absolute http(s) URLs
 * whose origin matches this app (or configured trusted app URLs).
 */
export const isTrustedMessageLink = (link) => {
  if (!link || typeof link !== 'string') {
    return false;
  }

  const trimmed = link.trim();
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
    return isTrustedAppPath(trimmed);
  }

  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return false;
    }
    if (!getTrustedOrigins().has(url.origin)) {
      return false;
    }
    return isTrustedAppPath(`${url.pathname}${url.search}`);
  } catch {
    return false;
  }
};
